import { gql } from '@apollo/client';

export const REVERSE_GEOCODE_QUERY = gql`
    query geocode($lat: Float!, $lon: Float!) {
        geocode(lat: $lat, lon: $lon)
    }
`;
